'use strict';

var _rollupPluginBabelHelpers = require('../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var PropTypes = require('prop-types');
var index = require('../ActionButton/index.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

var OptionPicker = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(OptionPicker, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(OptionPicker);

  function OptionPicker() {
    var _this;

    _rollupPluginBabelHelpers.classCallCheck(this, OptionPicker);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "state", {
      open: _this.props.open
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "handleClick", function (e) {
      _this.toggleOpen();

      e.preventDefault();
      e.stopPropagation();
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "handleClose", function () {
      return _this.close();
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "handleApply", function () {
      _this.handleClose();

      var dropDown = _this.props.dropDown;
      var originalHandler = dropDown.props.onApply;
      originalHandler.apply(dropDown);
    });

    _rollupPluginBabelHelpers.defineProperty(_rollupPluginBabelHelpers.assertThisInitialized(_this), "toggleOpen", function () {
      _this.setState(function (state) {
        return {
          open: !state.open
        };
      });
    });

    return _this;
  }

  _rollupPluginBabelHelpers.createClass(OptionPicker, [{
    key: "open",
    value: function open() {
      this.setState({
        open: true
      });
    }
  }, {
    key: "close",
    value: function close() {
      this.setState({
        open: false
      });
    }
  }, {
    key: "calculateClassName",
    value: function calculateClassName() {
      if (this.props.arrow) {
        if (this.state.open) {
          return "ds-mol-option-picker ds-mol-option-picker-open ".concat(this.props.className);
        }

        return "ds-mol-option-picker ds-mol-option-picker-closed ".concat(this.props.className);
      }

      return "ds-mol-option-picker ".concat(this.props.className);
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      if (!this.state.open) return null;
      return React__default['default'].cloneElement(this.props.dropDown, {
        onClose: this.handleClose,
        onApply: this.handleApply
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var actionButton = this.props.children ? React__default['default'].Children.map(this.props.children, function (child) {
        return React__default['default'].cloneElement(child, {
          onClick: _this2.handleClick,
          onSelect: _this2.toggleOpen
        });
      }) : /*#__PURE__*/React__default['default'].createElement(index, _rollupPluginBabelHelpers.extends({}, this.props, {
        onClick: this.handleClick,
        arrow: true,
        empty: true
      }));
      return /*#__PURE__*/React__default['default'].createElement("div", {
        className: this.calculateClassName()
      }, actionButton, this.renderMenu());
    }
  }]);

  return OptionPicker;
}(React__default['default'].Component);

_rollupPluginBabelHelpers.defineProperty(OptionPicker, "propTypes", {
  children: PropTypes__default['default'].node,
  className: PropTypes__default['default'].string,
  disabled: PropTypes__default['default'].bool,
  icon: PropTypes__default['default'].string,
  title: PropTypes__default['default'].string.isRequired,
  onClick: PropTypes__default['default'].func,
  arrow: PropTypes__default['default'].bool,
  open: PropTypes__default['default'].bool,
  dropDown: PropTypes__default['default'].element.isRequired
});

_rollupPluginBabelHelpers.defineProperty(OptionPicker, "defaultProps", {
  children: null,
  className: '',
  icon: null,
  disabled: false,
  arrow: false,
  onClick: function onClick() {},
  open: false
});

module.exports = OptionPicker;
